import React__default from 'react';
import { Cross, ArrowDown } from '@sravni/react-icons';
import { useStyles, isDefined } from '@sravni/react-utils';
import modules_c9d990f9 from '../styles/IconElement.module.less.js';

const IconElement = (props) => {
    const { visible, value, icon, handleClickClear } = props;
    const cx = useStyles(modules_c9d990f9);
    if (visible && isDefined(value) && value !== '') {
        return React__default.createElement(Cross, { className: cx('icon'), onClick: handleClickClear });
    }
    if (icon || icon === null) {
        return icon;
    }
    return (React__default.createElement(ArrowDown, { className: cx('icon', {
            [`is-arrow-turned`]: visible,
        }) }));
};

export { IconElement };
//# sourceMappingURL=IconElement.js.map
